import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  unityDetails: [],
}

const curatorTextureUploadFailedDialogSlicer = createSlice({
  name: "curatorTextureUploadFailedDialog",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setOpen: (state, { payload }) => {
      state.open = payload;
    },
    setUnityDetails: (state, { payload }) => {
      state.unityDetails = payload;
    }
  },
});

export const {
  setOpen,
  setUnityDetails,
} = curatorTextureUploadFailedDialogSlicer.actions;
export const curatorTextureUploadFailedDialogActions = curatorTextureUploadFailedDialogSlicer.actions;

export const curatorTextureUploadFailedDialogReducer = curatorTextureUploadFailedDialogSlicer.reducer;
export default curatorTextureUploadFailedDialogReducer;

export const selectCuratorTextureUploadFailedDialogOpen = (state) => state.curatorTextureUploadFailedDialog.open;
export const selectCuratorTextureUploadFailedDialogUnityDetails = (state) => state.curatorTextureUploadFailedDialog.unityDetails;